import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { LOAN_TERM_IN_MONTHS } from '../../utils/zhl-calculator.js';
import VALoanCalculator from '../VALoanCalculator/VALoanCalculator.js';
import { FieldConfig } from '../VALoanCalculator/VALoanCalculator.utils.js';

var _excluded = ["loanProgram"];
var _attributes;
var attributes = (_attributes = {}, _attributes[FieldConfig.homePrice.name] = {
  type: 'number',
  label: 'Default home price',
  default: 225000,
  control: 'number'
}, _attributes[FieldConfig.loanProgram.name] = {
  type: 'number',
  label: 'Default loan program',
  default: 360,
  control: 'select',
  choices: FieldConfig.loanProgram.options
}, _attributes[FieldConfig.interestRate.name] = {
  type: 'number',
  label: 'Default interest rate',
  default: 5,
  control: 'number'
}, _attributes[FieldConfig.downPayment.name] = {
  type: 'number',
  label: 'Default down payment',
  default: 45000,
  control: 'number'
}, _attributes[FieldConfig.downPaymentPercent.name] = {
  type: 'number',
  label: 'Default down payment percent',
  default: 20,
  control: 'number'
}, _attributes[FieldConfig.homeInsurance.name] = {
  type: 'number',
  label: 'Default home insurance',
  default: 945,
  control: 'number'
}, _attributes[FieldConfig.hoa.name] = {
  type: 'number',
  label: 'Default hoa dues',
  default: 0,
  control: 'number'
}, _attributes[FieldConfig.taxRate.name] = {
  type: 'number',
  label: 'Default property tax',
  default: 3600,
  control: 'number'
}, _attributes[FieldConfig.taxRatePercent.name] = {
  type: 'number',
  label: 'Default property tax percent',
  default: 1.2,
  control: 'number'
}, _attributes[FieldConfig.includeTaxesInsurance.name] = {
  type: 'boolean',
  default: 'true',
  label: 'Default include taxes/insurance',
  control: 'boolean'
}, _attributes[FieldConfig.includePMI.name] = {
  type: 'boolean',
  defaulat: 'true',
  label: 'Default include private mortgage insurance',
  control: 'boolean'
}, _attributes);
var MortgageCalculatorBlock = {
  Component: function Component() {
    return /*#__PURE__*/React.createElement(VALoanCalculator, {
      isMortgageComponent: true
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/mortgage-calculator',
    title: 'Mortgage Calculator',
    description: 'Estimate monthly payments.',
    icon: 'index-card',
    keywords: ['mortgages', 'calculators'],
    category: 'Calculators',
    supports: {
      customClassName: false,
      html: false
    },
    //added seperate attributes as default value varies for many fields
    attributes: attributes,
    //to avoid migration issues, add previous configs in deprecated section
    deprecated: [{
      attributes: {
        loanProgram: {
          type: 'string',
          default: 'Fixed30Year'
        }
      },
      save: function save() {
        return null;
      },
      isEligible: function isEligible(_ref) {
        var loanProgram = _ref.loanProgram;
        return typeof loanProgram === 'string';
      },
      migrate: function migrate(_ref2) {
        var loanProgram = _ref2.loanProgram,
          rest = _objectWithoutProperties(_ref2, _excluded);
        return Object.assign({}, rest, {
          loanProgram: LOAN_TERM_IN_MONTHS[loanProgram]
        });
      }
    }]
  }
};
var MortgageCalculatorBlock$1 = MortgageCalculatorBlock;

export { MortgageCalculatorBlock$1 as default };
